import { AttackPattern, PatternState } from '../AttackPattern.js';
import { ARENA } from '../../../../config/constants.js';

/** The Sirenreef's fair deception: steady rings are bait, pulsing rings are safe. */
export class Sirenreef extends AttackPattern {
  constructor({ minPhase = 0, config }) {
    super({ name: 'Sirenreef', telegraphDuration: 1.1, activeDuration: 1.8, minPhase });
    this.config = config;
  }

  onBegin(boss) {
    this._bait = { x: boss.x, y: boss.y };
    this._safe = { x: boss.x, y: boss.y };
    this._updateLure(boss);
  }

  onTelegraphTick(_dt, boss) {
    this._updateLure(boss);
  }

  _updateLure(boss) {
    this._bait = { x: boss.x, y: boss.y };
    this._safeAngle = Math.atan2(Math.sin(boss.y), Math.cos(boss.x));
    this._safe = {
      x: Math.min(ARENA.x + ARENA.width - 24, Math.max(ARENA.x + 24, boss.x + Math.cos(this._safeAngle) * this.config.offset)),
      y: Math.min(ARENA.y + ARENA.height - 24, Math.max(ARENA.y + 24, boss.y + Math.sin(this._safeAngle) * this.config.offset)),
    };
  }

  onActiveStart(_boss, _player, pool) {
    const count = this.config.count;
    const safeAngle = this._safeAngle ?? 0;
    // The bait ring is the kill zone, but it has one deliberate opening aimed
    // at the bright safe beacon. The lure is now a real choice rather than a
    // decorative marker: skilled players read the beacon and move through the
    // opening while the rest of the ring sweeps past.
    for (let i = 0; i < count; i++) {
      const angle = (i / count) * Math.PI * 2;
      let diff = angle - safeAngle;
      while (diff > Math.PI) diff -= Math.PI * 2;
      while (diff < -Math.PI) diff += Math.PI * 2;
      if (Math.abs(diff) < 0.20) continue;
      pool.fire({ x: this._bait.x, y: this._bait.y, vx: Math.cos(angle) * this.config.speed, vy: Math.sin(angle) * this.config.speed, radius: 2.5, damage: this.config.damage, color: '#ff6b9d', lifetime: 4 });
    }
  }

  getVisual() {
    if (this.state !== PatternState.TELEGRAPH) return null;
    return { kind: 'sirenreef', bait: this._bait, safe: this._safe, t: 1 - this._timer / this.telegraphDuration };
  }
}
